import {
  CustomDynamicDropdownProps,
  DropdownItem,
} from "../../../Interfaces/dropdownInterfaces";
import CustomStaticDropdown from "./CustomStaticDropdown";
import { useState, useEffect } from "react";

const CustomDynamicDropdown = <T extends DropdownItem>({
  dropdown,
  getData,
  onChange,
  inputId,
  value,
  sendOptionsOnValueChange,
}: CustomDynamicDropdownProps<T>) => {
  const [options, setOptions] = useState<Array<T>>([]);
  useEffect(() => {
    fetchData();
  }, [inputId]);

  const fetchData = () => {
    setOptions([]);
    getData(inputId)
      .then((res) => {
        setOptions(res);
      })
      .catch((e) => {
        setOptions([]);
      });
  };

  useEffect(() => {
    if (sendOptionsOnValueChange && options.length)
      sendOptionsOnValueChange(options);
  }, [value?.id, options]);

  if (options.length === 0) {
    return <></>;
  }

  return (
    <CustomStaticDropdown
      options={options}
      dropdown={dropdown}
      value={value}
      onChange={onChange}
    />
  );
};

export default CustomDynamicDropdown;
